import React from "react";
import { Form } from "antd";
import { useTranslation } from "react-i18next";
import StyledTextInput from "src/components/reusable/StyledTextInput";
import { MAX_COMPANY_NAME_LENGTH } from "../Utils/SocialListeningConstants";

interface BrandFormFieldsProps {
  scope: "brandForm" | "competitiveForm";
  handlePlaceholder: string;
  namePath?: (string | number)[];
}

const BrandFormFields: React.FC<BrandFormFieldsProps> = ({ scope, handlePlaceholder, namePath = [] }) => {
  const { t } = useTranslation();
  const text = (key: string) => t(`socialListingAgent.${scope}.${key}`);

  const optionalFields = [
    { name: "instagram", label: "instagramHandleLabel", placeholder: handlePlaceholder },
    { name: "facebook", label: "facebookPageIdLabel", placeholder: text("facebookPageIdPlaceholder") },
    { name: "tiktok", label: "tiktokUsernameLabel", placeholder: handlePlaceholder },
    { name: "redditSubreddits", label: "redditSubredditsLabel", placeholder: text("redditSubredditsPlaceholder") },
  ];

  return (
    <>
      <Form.Item
        label={text("brandNameLabel")}
        className="brand-form-label"
        name={[...namePath, "brandName"]}
        rules={[{ required: true, whitespace: true, message: text("brandNameRequired") }]}
      >
        <StyledTextInput
          placeholder={text("brandNamePlaceholder")}
          className="brand-placeholder"
          maxLength={MAX_COMPANY_NAME_LENGTH}
        />
      </Form.Item>

      {optionalFields.map(({ name, label, placeholder }) => (
        <Form.Item key={name} label={text(label)} className="brand-form-label" name={[...namePath, name]}>
          <StyledTextInput placeholder={placeholder} className="brand-placeholder" />
        </Form.Item>
      ))}
    </>
  );
};

export default BrandFormFields;
